import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { NavLink as AtlasNavLink } from '@diligentcorp/atlas-web-component-global-nav/lib/react.js';
import { RoutedNavLink } from '@diligentcorp/atlas-web-component-global-nav/lib/react-router.js';
import AcademyIcon from '@diligentcorp/atlas-react-icons/dist/esm/lens/Academy.js';
import BookIcon from '@diligentcorp/atlas-react-icons/dist/esm/lens/Book.js';
import ExpandLeftIcon from '@diligentcorp/atlas-react-icons/dist/esm/lens/ExpandLeft.js';

interface ContentAuthoringNavPanelProps {
  /** Collapses the drill-down panel without navigating when the user opened it from elsewhere. */
  onBack: () => void;
}

/**
 * Second-level Content authoring nav panel (Figma drill-down).
 * Shown when the user is on Templates or Courses, or after expanding Content authoring.
 * Back restores the main Compliance Education nav panel.
 */
export function ContentAuthoringNavPanel({ onBack }: ContentAuthoringNavPanelProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <>
      <RouterNavLink to="." onClick={(event) => {
        event.preventDefault();
        onBack();
      }}>
        {() => (
          <AtlasNavLink
            as="span"
            label={t('nav.compliance_education.back_to_compliance_education')}
            variant="secondary"
          >
            <ExpandLeftIcon slot="icon" />
          </AtlasNavLink>
        )}
      </RouterNavLink>
      <RoutedNavLink to="/templates" label={t('nav.compliance_education.templates')}>
        <BookIcon slot="icon" />
      </RoutedNavLink>
      <RoutedNavLink to="/authoring/courses" label={t('nav.compliance_education.authoring_courses')}>
        <AcademyIcon slot="icon" />
      </RoutedNavLink>
    </>
  );
}
